var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.$u.addStyle(_vm.customStyle), _vm.wrapperStyle])
  var s1 = _vm.__get_style([_vm.barStyle])
  var g0 =
    _vm.current > 0 &&
    _vm.current < _vm.list.length - 1 &&
    _vm.mode === "subsection" &&
    "u-subsection__bar--center"
  var g1 =
    _vm.current === _vm.list.length - 1 &&
    _vm.mode === "subsection" &&
    "u-subsection__bar--last"
  var l0 = _vm.__map(_vm.list, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var s2 = _vm.__get_style([_vm.itemStyle(index)])
    var g2 =
      index < _vm.list.length - 1 && "u-subsection__item--no-border-right"
    var g3 = index === _vm.list.length - 1 && "u-subsection__item--last"
    var s3 = _vm.__get_style([_vm.textStyle(index)])
    var m0 = _vm.getText(item)
    return {
      $orig: $orig,
      s2: s2,
      g2: g2,
      g3: g3,
      s3: s3,
      m0: m0,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        s1: s1,
        g0: g0,
        g1: g1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }